<template>
  <el-dialog v-if="dataInfo !== null" :title="title" @closed="_closed" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="700px" custom-class="location-edit-dialog" :modal-append-to-body="false">
    <div class="dialog-content" :style="{ height: dialogHeight + 'px' }">
      <el-tabs v-model="activeTab" type="border-card" class="fixed-tabs">
        <!-- 第一个Tab：基础信息 -->
        <el-tab-pane label="基础信息" name="base">
          <div class="tab-content-scroll">
            <el-form ref="formRef" :model="formData" :rules="rules" label-width="100px" style="margin-top: 10px;">
              <el-form-item label="地点名称" required prop="location_name">
                <el-input v-model="formData.location_name" placeholder="请输入地点名称"></el-input>
              </el-form-item>
              <el-form-item label="地点描述">
                <el-input v-model="formData.location_desc" type="textarea" :rows="3" placeholder="请输入地点描述"></el-input>
              </el-form-item>
              <el-form-item label="所属区域">
                <el-input v-model="formData.area" placeholder="例如：一楼/办公区"></el-input>
              </el-form-item>
              <el-form-item label="保洁周期">
                <el-input-number v-model="formData.clean_cycle" :min="1" :max="30" label="保洁周期"></el-input-number>
                <div class="tips">单位：天，即每隔几天清洁一次</div>
              </el-form-item>
              <el-form-item label="是否启用">
                <el-switch v-model="formData.is_enabled"></el-switch>
              </el-form-item>
              <el-form-item label="地点维码" prop="assetName" v-if="dataInfo.location_id">
                <el-image style="width: 200px; height: 200px" :src="dataInfo.qrImg" :fit="fit"></el-image>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 第二个Tab：比对点管理 -->
        <el-tab-pane label="比对点管理" name="point">
          <div class="tab-content-scroll">
            <div class="point-manage">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addPoint">添加比对点</el-button>
              <span class="weight-total" :class="{ error: weightTotal !== 100 }">
                权重总和：{{ weightTotal }}%
                <i v-if="weightTotal !== 100" class="el-icon-warning"> (必须等于100%)</i>
              </span>
            </div>
            <el-row :gutter="16" class="point-cards">
              <el-col :span="24" v-for="(point, index) in points" :key="index">
                <el-card class="point-card" shadow="hover">
                  <!-- 右上角删除按钮 -->
                  <div class="delete-btn" @click="removePoint(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-row :gutter="12">
                    <!-- 左边：图片 -->
                    <el-col :span="8" class="point-image-col bigView">
                      <l-upload-img v-model="point.standard_image_url" :mini="true" :size="120"></l-upload-img>
                    </el-col>
                    <!-- 右边：编辑内容 -->
                    <el-col :span="16" class="point-content-col">

                      <div class="point-form-item">
                        <span class="point-label">权重(%)</span>
                        <el-input-number v-model="point.weight" :min="0" :max="100" size="mini" @change="checkWeight"></el-input-number>
                      </div>
                                            <div class="point-form-item">
                        <span class="point-label">比对点名称</span>
                        <el-input v-model="point.point_name" size="mini" placeholder="请输入名称"></el-input>
                      </div>
                      <div class="point-form-item">
                        <span class="point-label">启用状态</span>
                        <el-switch v-model="point.is_enabled" size="mini" @change="checkWeight"></el-switch>
                      </div>
                      <div class="point-form-item sort-btns">
                        <span class="point-label">排序</span>
                        <el-button-group size="mini">
                          <el-button icon="el-icon-top" :disabled="index === 0" @click="movePoint(index, -1)"></el-button>
                          <el-button icon="el-icon-bottom" :disabled="index === points.length - 1" @click="movePoint(index, 1)"></el-button>
                        </el-button-group>
                      </div>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancel">取 消</el-button>
      <el-button type="primary" @click="_submit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store'
import LUploadImg from '@/lgh/components/uploadimg/src/main.vue'
export default {
  name: 'CleanLocationEdit',
  components: {
    LUploadImg
  },
  computed: {
    userInfo() {
      return store.state.userInfo
    },
    weightTotal() {
      return this.points.filter(p => p.is_enabled).reduce((sum, p) => sum + (p.weight || 0), 0)
    }
  },
  data() {
    return {
      title: '',
      visible: true,
      isAdd: true,
      dataInfo: null,
      activeTab: 'base', // 当前激活的Tab
      dialogHeight: 0, // 弹窗内容区高度
      points: [], // 比对点列表
      formData: {
        location_id: 0,
        enterprise_code: '',
        location_name: '',
        location_desc: '',
        area: '',
        standard_image_url: '',
        qrcode_url: '',
        qrcode_content: '',
        clean_cycle: 1,
        is_enabled: true,
        create_time: '2000-1-1',
        create_user_id: null,
        create_user_name: '',
        remark: ''
      },
      rules: {
        location_name: [
          { required: true, message: '请输入地点名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    if (this.dataInfo && !this.isAdd) {
      Object.assign(this.formData, this.dataInfo)
    }
  },
  mounted() {
    this.calcHeight()
    window.addEventListener('resize', this.calcHeight)
    if (this.dataInfo && !this.isAdd) {
      Object.assign(this.formData, this.dataInfo)
      this.loadPoints()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcHeight)
  },
  methods: {
    // 计算弹窗高度 = 屏幕高度的80% - 头部高度 - 底部按钮高度
    calcHeight() {
      const screenHeight = window.innerHeight
      this.dialogHeight = Math.floor(screenHeight * 0.8) - 54 - 64
    },
    _closed() {
      this.onclosed()
    },
    _cancel() {
      this.visible = false
      this.cancel && this.cancel()
    },
    async _submit() {
      const result = await this.submit()
      if (result === true) {
        this.visible = false
        this.onsuccess && this.onsuccess(result)
      }
    },
    async submit() {
      let valid = false
      await this.$refs.formRef.validate((result) => {
        valid = result
      })
      if (!valid) {
        return false
      }

      // 校验权重
      if (this.points.length > 0 && this.weightTotal !== 100) {
        this.$message.error('启用的比对点权重总和必须等于100%')
        return false
      }

      this.formData.enterprise_code = this.userInfo.enterpriseCode
      this.formData.create_user_id = this.userInfo.userId
      this.formData.create_user_name = this.userInfo.fullName

      let locationId
      if (this.isAdd) {
        const res = await this.$lgh.post('api/clean/location/add', this.formData)
        locationId = res.data.location_id
      } else {
        await this.$lgh.post('api/clean/location/update', this.formData)
        locationId = this.formData.location_id
      }

      // 保存比对点
      if (this.points.length > 0) {
        await this.$lgh.post('api/clean/location/point/batch-save', { locationId: locationId, points: this.points })
      }

      return true
    },
    // 加载比对点列表
    async loadPoints() {
      const res = await this.$lgh.get('api/clean/location/point/list', { locationId: this.formData.location_id })
      this.points = res || []
    },
    // 添加比对点
    addPoint() {
      this.points.push({
        point_id: 0,
        location_id: this.formData.location_id,
        point_name: '',
        standard_image_url: '', // 'https://njzrt.oss-cn-qingdao.aliyuncs.com/file/2026-04-22/75957e2e4f764b0e9d13d534e1f66f9e.jpg',
        weight: 0,
        sort: this.points.length + 1,
        is_enabled: true,
        create_time: new Date(),
        remark: ''
      })
    },
    // 删除比对点
    removePoint(index) {
      this.$confirm('确定要删除该比对点吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.points.splice(index, 1)
        this.checkWeight()
      }).catch(() => {})
    },
    // 移动比对点排序
    movePoint(index, direction) {
      const temp = this.points[index]
      this.points.splice(index, 1)
      this.points.splice(index + direction, 0, temp)
    },
    // 检查权重
    checkWeight() {
      // 这里可以添加自动调整逻辑，暂时只触发computed更新
    }
  }
}
</script>

<style>
/* 弹窗自定义class，需要去掉scoped才能生效 */
.location-edit-dialog .el-dialog__body {
  padding: 0 !important;
}
.location-edit-dialog .el-dialog__body {
  max-height: 520px;
  overflow: hidden;
}

.bigView .avatar {
  width: 200px!important;
  height: 120px!important;
  display: block;
}
</style>

<style scoped>
.dialog-content {
  height: 520px;
  display: flex;
  flex-direction: column;
}
.fixed-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: none;
  overflow: hidden;
}
.fixed-tabs >>> .el-tabs__header {
  margin: 0;
  flex-shrink: 0;
  border-bottom: 1px solid #ebeef5;
  background: #fafafa;
}
.fixed-tabs >>> .el-tabs__content {
  flex: 1;
  overflow: hidden;
}
.tab-content-scroll {
  height: 475px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 20px 20px;
  box-sizing: border-box;
}
/* 滚动条美化 */
.tab-content-scroll::-webkit-scrollbar {
  width: 6px;
}
.tab-content-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
.tab-content-scroll::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.tips {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}
.point-manage {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.weight-total {
  font-size: 14px;
  font-weight: 500;
}
.weight-total.error {
  color: #f56c6c;
}
/* 卡片布局 */
.point-cards {
  margin-top: 10px;
}
.point-card {
  margin-bottom: 16px;
  position: relative;
}
/* 右上角删除按钮 */
.delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background-color: #f56c6c;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  z-index: 10;
  transition: all 0.2s;
}
.delete-btn:hover {
  background-color: #f5222d;
  transform: scale(1.1);
}
/* 图片列 */
.point-image-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border-right: 1px solid #ebeef5;
}
/* 内容列 */
.point-content-col {
  padding: 8px 0 8px 12px;
}
.point-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.point-form-item:last-child {
  margin-bottom: 0;
}
.point-label {
  width: 68px;
  font-size: 12px;
  color: #606266;
  flex-shrink: 0;
}
.sort-btns .el-button-group {
  margin-left: 0;
}

</style>
